'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import getErrorNotificationBody from './ErrorNotificationBody';
const LEAD_AD_ERRORS = {
  REACH_TOO_LOW: __message => ({
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.leadAdCreation.sorryHeader"
    }),
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.leadAdCreation.reachTooLow"
    })
  }),
  UNUSABLE_FORM: __message => ({
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.leadAdCreation.sorryHeader"
    }),
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.leadAdCreation.unusableFacebookForm"
    })
  }),
  PAYMENT_METHOD_MISSING: __message => ({
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.leadAdCreation.sorryAdAccount"
    }),
    text: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "errors.leadAdCreation.paymentMethodMissing.FACEBOOK.tooltip_jsx",
      elements: {
        Link: UILink
      },
      options: {
        external: true,
        href: 'https://www.facebook.com/business/help/132073386867900?helpref=page_content',
        className: 'display-block m-top-1'
      }
    })
  }),
  FLAGGED_CONTENT: __message => ({
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.leadAdCreation.sorryHeader"
    }),
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.leadAdCreation.flaggedContent"
    })
  }),
  INSUFFICIENT_CAMPAIGN_GROUP_BUDGET: message => ({
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.leadAdCreation.sorryHeader"
    }),
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.leadAdCreation.campaignGroupBudgetTooLow"
    }),
    details: message
  }),
  EMAIL_NEEDS_VERIFICATION: __message => ({
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.leadAdCreation.sorryHeader"
    }),
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.leadAdCreation.emailNeedsVerification"
    })
  }),
  ACCOUNT_BANNED: __message => ({
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.leadAdCreation.accountBannedHeader"
    }),
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.leadAdCreation.accountBannedText"
    })
  })
};

const getLeadAdCreationErrorBody = (actionType, errorType, {
  message
}) => {
  const errorData = LEAD_AD_ERRORS[errorType];

  if (!errorData) {
    return null;
  }

  return getErrorNotificationBody(Object.assign({
    actionType
  }, errorData(message)));
};

export default getLeadAdCreationErrorBody;